export default function SocialIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg width={size} height={size} viewBox='0 0 38 38' fill='currentColor'>
        <path d='M14.3633 15C17.1247 15 19.3633 12.7614 19.3633 10C19.3633 7.23858 17.1247 5 14.3633 5C11.6019 5 9.36328 7.23858 9.36328 10C9.36328 12.7614 11.6019 15 14.3633 15ZM21.3633 10C21.3633 13.866 18.2293 17 14.3633 17C10.4973 17 7.36328 13.866 7.36328 10C7.36328 6.13401 10.4973 3 14.3633 3C18.2293 3 21.3633 6.13401 21.3633 10Z' />
        <path d='M24.7257 14.9092C26.8846 14.9092 28.6348 13.159 28.6348 11.0001C28.6348 8.84116 26.8846 7.091 24.7257 7.091C24.1734 7.091 23.7257 6.64328 23.7257 6.091C23.7257 5.53871 24.1734 5.091 24.7257 5.091C27.9892 5.091 30.6348 7.73659 30.6348 11.0001C30.6348 14.2636 27.9892 16.9092 24.7257 16.9092C24.1734 16.9092 23.7257 16.4615 23.7257 15.9092C23.7257 15.3569 24.1734 14.9092 24.7257 14.9092Z' />
        <path d='M3 25C3 22.2386 5.23858 20 8 20H21C23.7614 20 26 22.2386 26 25V29C26 29.5523 25.5523 30 25 30C24.4477 30 24 29.5523 24 29V25C24 23.3431 22.6569 22 21 22H8C6.34315 22 5 23.3431 5 25V29C5 29.5523 4.55228 30 4 30C3.44772 30 3 29.5523 3 29V25Z' />
        <path d='M27 20C27 19.4477 27.4477 19 28 19C30.7614 19 33 21.2386 33 24V28C33 28.5523 32.5523 29 32 29C31.4477 29 31 28.5523 31 28V24C31 22.3431 29.6569 21 28 21C27.4477 21 27 20.5523 27 20Z' />
      </svg>
    </span>
  );
}
